/*----------------------------------
- DEPENDANCES
----------------------------------*/

// Npm
import React from 'react';

// Core
import { Router } from '@app';

// app
import Listing from './Listing';
import DomainFilters from '@/client/pages/platform/domains/Listing/Filters';

// Types
import type { TDomainsList } from '@/server/services/Domains';
import type { TDomainsStats } from '@/server/services/Stats';

// App
import Page from '../_page';

/*----------------------------------
- CONTROLEUR
----------------------------------*/
Router.page('/domains/tld/:tld', ({ api , request }) => {

    const { domains } = api.fetch({
        domains: api.post<TDomainsList>('/domains', { ...request.data })
    });

    return (
        <Page title={domains.title} description={domains.description}>

            <Listing domains={domains} />
        </Page>
    )
});